var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeart = function SvgIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-heart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.62 13.24c-1.216 1.58-1.953 3.737-1.953 5.99 0 5.05 3.304 9.288 6.792 12.34a36.5 36.5 0 0 0 6.53 4.522l.21-.12a39.366 39.366 0 0 0 6.336-4.566c3.501-3.117 6.798-7.355 6.798-12.176 0-2.253-.737-4.41-1.953-5.99-1.213-1.574-2.869-2.54-4.74-2.54-2.585 0-4.59 1.718-5.892 4.422L24 16.676l-.748-1.554c-1.302-2.704-3.307-4.422-5.893-4.422-1.87 0-3.526.966-4.739 2.54M24 37.05l-.362.767-.004-.002-.01-.005-.033-.017-.127-.065q-.165-.084-.466-.248a38.209 38.209 0 0 1-6.624-4.62C12.78 29.716 9 25.045 9 19.23c0-2.614.851-5.146 2.31-7.04C12.773 10.29 14.88 9 17.36 9c2.919 0 5.14 1.669 6.64 4.024C25.5 10.669 27.72 9 30.64 9c2.48 0 4.587 1.29 6.05 3.19 1.46 1.894 2.31 4.426 2.31 7.04 0 5.595-3.786 10.267-7.369 13.457a41 41 0 0 1-7.078 5.027q-.081.045-.126.068l-.033.018-.01.005-.003.002zm0 0 .38.757-.368.193-.374-.183z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-heart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgIconHeart;